import { Wallet } from "lucide-react";
import type { AppInfo } from "@/shared/apps";

// Where the app sits in the shell: its tabs, "+ New" entries, settings and first steps.
export const app: AppInfo = {
  key: "payroll",
  icon: Wallet,
  tabs: [
    { to: "/payroll", label: "nav.payroll", perm: ["payroll.run.read"] },
    { to: "/payroll/advances", label: "nav.advances", perm: ["payroll.advance.read"] },
    { to: "/payroll/end-of-service", label: "nav.endOfService", perm: ["payroll.run.read"] },
    { to: "/payroll/bonuses", label: "nav.bonuses", perm: ["payroll.run.read"] },
  ],
  settings: { to: "/settings/payroll", perm: ["payroll.settings.read"] },
  setup: { first_run: "/payroll" },
};
